import React, { useState } from "react";
import styled from "styled-components";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate form fields
    if (!formData.name || !formData.email || !formData.message) {
      alert("Please fill in all fields.");
      return;
    }

    // Build the email body
    const emailBody = `Name: ${formData.name}\nEmail: ${formData.email}\nMessage: ${formData.message}`;

    // Create a mailto URL
    const mailtoURL = `mailto:djbezi@topeventsentertainment.co.uk?subject=Contact Form Submission&body=${encodeURIComponent(
      emailBody
    )}`;

    // Open the default email client
    window.location.href = mailtoURL;
  };

  const handleReset = () => {
    setFormData({
      name: "",
      email: "",
      message: "",
    });
  };

  return (
    <ContactWrap id="contactus">
      <Title>Get in touch</Title>
      <ContactForm onSubmit={handleSubmit}>
        <FormGroup>
          <Label htmlFor="name">Name:</Label>
          <Input
            type="text"
            id="name"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
          />
        </FormGroup>
        <FormGroup>
          <Label htmlFor="email">Email:</Label>
          <Input
            type="email"
            id="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleChange}
          />
        </FormGroup>
        <FormGroup>
          <Label htmlFor="message">Message:</Label>
          <TextArea
            id="message"
            name="message"
            placeholder="Your Message"
            value={formData.message}
            onChange={handleChange}
          ></TextArea>
        </FormGroup>
        <ButtonGroup>
          <SubResButton type="submit">Submit</SubResButton>
          <SubResButton type="button" onClick={handleReset}>
            Reset
          </SubResButton>
        </ButtonGroup>
      </ContactForm>
    </ContactWrap>
  );
};

export default ContactUs;

const ContactWrap = styled.div`
  width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #2a2326;
  font-family: "Exo", sans-serif;
`;

const Title = styled.h2`
  font-size: 28px;
  margin-bottom: 20px;
`;

const ContactForm = styled.form`
  width: 80%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 50px 40px;

  @media (max-width: 767px) {
    padding: 20px 0;
  }
`;

const FormGroup = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  text-align: left;
  margin-bottom: 20px;
`;

const Label = styled.label`
  font-size: 16px;
  margin-bottom: 8px;
  color: rgb(192, 192, 192);
`;

const Input = styled.input`
  padding: 10px;
  font-size: 14px;
  border: none;
  border-bottom: 1px solid #ccc;
  background: transparent;
  outline: none;
  caret-color: white;
  color: white;
`;

const TextArea = styled.textarea`
  padding: 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  resize: vertical;
  border: none;
  border-bottom: 1px solid #ccc;
  background: transparent;
  outline: none;
  caret-color: white;
  color: white;
`;

const ButtonGroup = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 10px;
`;

const SubResButton = styled.button`
  width: 100px;
  background-color: #fff;
  color: rgb(192, 192, 192);
  padding: 5px 10px;
  font-size: 16px;
  cursor: pointer;
  border: none;
  border-radius: 4px;
  border: 2px solid rgb(192, 192, 192);
  transition: background-color 0.3s color 0.3s border 0.3s;
  font-weight: bold;

  &:hover {
    background-color: rgb(192, 192, 192);
    color: white;
    border: 1px solid white;
  }
`;
